import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import i18n from '@/i18n';
import { RootState } from '../interfaces/rootState';
import { httpCommpix } from '@/util/HTTPCommpix'; // Import getAuthPayload
import {
  ProcessPayoutsPayload, AuthorizePayoutsPayload, ProcessPayoutsResponse, ProcessPayoutsState
} from '@/store/interfaces/commpix-api/processPayout';
import processPayoutsTypes from '@/store/types/processPayouts';
const namespaced = true;

const state: ProcessPayoutsState = {
  response: null,
  error: null,
};

const mutations: MutationTree<ProcessPayoutsState> = {
  [processPayoutsTypes.mutations.SET_RESPONSE](state, response: ProcessPayoutsResponse | null) {
    state.response = response;
  },
  [processPayoutsTypes.mutations.SET_ERROR](state, error: string | null) {
    state.error = error;
  },
  [processPayoutsTypes.mutations.CLEAR_STATE](state) {
    state.response = null;
    state.error = null;
  },
};

const actions: ActionTree<ProcessPayoutsState, RootState> = {
  async [processPayoutsTypes.actions.PROCESS_PAYOUTS]({ commit, }, payload: ProcessPayoutsPayload): Promise<ProcessPayoutsResponse> {
    commit(processPayoutsTypes.mutations.CLEAR_STATE);
    try {
      const response = await httpCommpix.post('/payouts/process', payload);
      commit(processPayoutsTypes.mutations.SET_RESPONSE, response.data);
      return response.data;
    } catch (error) {
      let message = i18n.t('pix.processPayouts.error.default');
      if (error instanceof Error) {
        message = error.message;
      }
      commit(processPayoutsTypes.mutations.SET_ERROR, message);
      return Promise.reject(message);
    }
  },

  async [processPayoutsTypes.actions.AUTHORIZE_PAYOUTS]({ commit, }, payload: AuthorizePayoutsPayload): Promise<ProcessPayoutsResponse> {
    commit(processPayoutsTypes.mutations.CLEAR_STATE);
    try {
      const response = await httpCommpix.post('/payouts/pending-authorization/authorize', payload);
      commit(processPayoutsTypes.mutations.SET_RESPONSE, response.data);
      return response.data;
    } catch (error) {
      let message = i18n.t(payload.authorized ? 'pix.pendingPayouts.messages.errorAuthorize' : 'pix.pendingPayouts.messages.errorReject');
      if (error instanceof Error) {
        message = error.message;
      }
      commit(processPayoutsTypes.mutations.SET_ERROR, message);
      return Promise.reject(message);
    }
  },

  async [processPayoutsTypes.actions.CANCEL_PAYOUTS]({ commit, }, payload: ProcessPayoutsPayload): Promise<ProcessPayoutsResponse> {
    commit(processPayoutsTypes.mutations.CLEAR_STATE);
    try {
      const response = await httpCommpix.post('/payouts/cancel', payload);
      commit(processPayoutsTypes.mutations.SET_RESPONSE, response.data);
      return response.data;
    } catch (error) {
      let message = i18n.t('pix.cancelPayouts.error.default');
      if (error instanceof Error) {
        message = error.message;
      }
      commit(processPayoutsTypes.mutations.SET_ERROR, message);
      return Promise.reject(message);
    }
  },

  clearPayoutsState({ commit, }) {
    commit(processPayoutsTypes.mutations.CLEAR_STATE);
  },
};

const getters: GetterTree<ProcessPayoutsState, RootState> = {
  [processPayoutsTypes.getters.GET_PROCESS_PAYOUT_RESPONSE]: state => state.response,
  [processPayoutsTypes.getters.GET_PROCESS_PAYOUT_ERRORS]: state => state.error,
};

export const processPayouts: Module<ProcessPayoutsState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};

export default processPayouts;
